import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import get from 'lodash/get'

import EmailPreferencesForm from '../../components/settings/email-preferences-form'
import {
  loadEmailPreferences,
  updateEmailPreferences
} from '../../actions/settings'

const fields = [
  'permanentIssues',
  'needsWork',
  'needsReview',
  'unsatisfactory',
  'emergencyServices',
  'billable',
  'unableToComplete',
  'delayed',
  'workOrderDelay',
  'workTrackerMonthlyReports'
]

const mapStateToProps = (state, props) => {
  const emailPreferences = get(state, 'settings.emailPreferences', undefined)
  const permanentIssues = get(emailPreferences, 'permanentIssues', false)
  const needsWork = get(emailPreferences, 'needsWork', false)
  const needsReview = get(emailPreferences, 'needsReview', false)
  const unsatisfactory = get(emailPreferences, 'unsatisfactory', false)
  const emergencyServices = get(emailPreferences, 'emergencyServices', false)
  const billable = get(emailPreferences, 'billable', false)
  const unableToComplete = get(emailPreferences, 'unableToComplete', false)
  const delayed = get(emailPreferences, 'delayed', false)
  const workOrderDelay = get(emailPreferences, 'workOrderDelay', false)
  const workTrackerMonthlyReports = get(emailPreferences, 'workTrackerMonthlyReports', false)
  const userType = get(state.auth, 'session.type')

  return {
    initialValues: {
      permanentIssues,
      needsWork,
      needsReview,
      unsatisfactory,
      emergencyServices,
      billable,
      unableToComplete,
      delayed,
      workOrderDelay,
      workTrackerMonthlyReports
    },
    userType
  }
}

const mapDispatchToProps = (dispatch, props) => {
  dispatch(loadEmailPreferences())

  return {
    onSubmit(data) {
      dispatch(updateEmailPreferences(data))
    }
  }
}

export default reduxForm(
  {
    fields,
    form: 'EmailNotificationPereferences'
  },
  mapStateToProps,
  mapDispatchToProps
)(EmailPreferencesForm)



// WEBPACK FOOTER //
// ./src/containers/settings/email-preferences-form-container.js